import {
  ADD_NEW_INTERVIEWER,
  ADD_NEW_INTERVIEWER_FAILED,
  ADD_NEW_INTERVIEWER_SUCCESS,
  GET_INTERVIEWERS_DATA,
  GET_INTERVIEWERS_DATA_ERROR,
  GET_INTERVIEWERS_DATA_SUCCESS,
  GET_SCHEDULER_INTERVIEW_DETAILS,
  GET_SCHEDULER_INTERVIEW_DETAILS_FAIL,
  GET_SCHEDULER_INTERVIEW_DETAILS_SUCCESS,
  POST_INTERVIEW_ROUND,
  POST_INTERVIEW_ROUND_FAIL,
  POST_INTERVIEW_ROUND_SUCCESS,
  REJECT_CANDIDATE,
  REJECT_CANDIDATE_FAILURE,
  REJECT_CANDIDATE_SUCCESS,
  SCHEDULE_INTERVIEW,
  SCHEDULE_INTERVIEW_FAILURE,
  SCHEDULE_INTERVIEW_SUCCESS,
  SCHEDULE_VIDEO_INTERVIEW,
  UPDATE_INTERVIEW_DETAILS,
  UPDATE_INTERVIEW_DETAILSS_FAIL,
  UPDATE_INTERVIEW_DETAILS_SUCCESS,
  GET_INTERVIEW_ROUNDS,
  GET_INTERVIEW_ROUNDS_SUCCESS,
  GET_INTERVIEW_ROUNDS_FAILURE,
  GET_INTERVIEW_RECORDINGS,
  GET_INTERVIEW_RECORDINGS_SUCCESS,
  GET_INTERVIEW_RECORDINGS_FAILURE,
} from "./actionTypes";

const initialState = {
  loader: false,
  interviewDetails: null,
  interviewerList: null,
  interviewError: null,
  addInterviewRoundData: null,
  scheduleInterviewData: null,
  updateInterviewMessage: null,
  jobInterviewRounds: null,
  interviewRecordings: {},
  interviewRecordingsLoading: {},
  interviewRecordingsError: {},
};

const InterviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEDULER_INTERVIEW_DETAILS:
      state = {
        ...state,
        loader: true,
        interviewDetails: null,
        interviewError: null,
      };
      break;
    case GET_SCHEDULER_INTERVIEW_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        interviewDetails: action.payload,

        interviewError: null,
      };
      break;
    case GET_SCHEDULER_INTERVIEW_DETAILS_FAIL:
      state = {
        ...state,
        loader: false,
        interviewError: action.payload,
        interviewDetails: null,
      };
      break;
    case GET_INTERVIEWERS_DATA:
      state = {
        ...state,
        loader: true,
        interviewerList: null,
        interviewError: null,
      };
      break;
    case GET_INTERVIEWERS_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        interviewerList: action.payload,
        interviewError: null,
      };
      break;
    case GET_INTERVIEWERS_DATA_ERROR:
      state = {
        ...state,
        loader: false,
        interviewerList: null,
        interviewError: action.payload,
      };
      break;
    case POST_INTERVIEW_ROUND:
      state = {
        ...state,
        loader: true,
        addInterviewRoundData: null,
        interviewError: null,
      };
      break;
    case POST_INTERVIEW_ROUND_SUCCESS:
      state = {
        ...state,
        loader: false,
        addInterviewRoundData: action.payload,
        interviewError: null,
      };
      break;
    case POST_INTERVIEW_ROUND_FAIL:
      state = {
        ...state,
        loader: false,
        addInterviewRoundData: null,
        interviewError: action.payload,
      };
      break;
    case SCHEDULE_INTERVIEW:
      state = {
        ...state,
        loader: true,
        scheduleInterviewData: null,
        interviewError: null,
      };
      break;
    case SCHEDULE_INTERVIEW_SUCCESS:
      state = {
        ...state,
        loader: false,
        scheduleInterviewData: action.payload,
        interviewError: null,
      };
      break;
    case SCHEDULE_VIDEO_INTERVIEW:
      state = {
        ...state,
        loader: false,
        videoInterviewCode: action.payload,
      };
      break;
    case SCHEDULE_INTERVIEW_FAILURE:
      state = {
        ...state,
        loader: false,
        interviewError: action.payload,
        scheduleInterviewData: null,
      };
      break;
    case ADD_NEW_INTERVIEWER:
      state = {
        ...state,
        loader: true,
      };
      break;
    case ADD_NEW_INTERVIEWER_SUCCESS:
      state = {
        ...state,
        loader: false,
        interviewError: null,
        updateInterviewMessage: action.payload,
      };
      break;
    case ADD_NEW_INTERVIEWER_FAILED:
      state = {
        ...state,
        loader: false,
        interviewError: action.payload,
        updateInterviewMessage: null,
      };
      break;
    case UPDATE_INTERVIEW_DETAILS:
      state = {
        ...state,
        loader: true,
        updateInterviewMessage: null,
        interviewError: null,
      };
      break;
    case UPDATE_INTERVIEW_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        updateInterviewMessage: action.payload,
        interviewError: null,
      };

      break;
    case UPDATE_INTERVIEW_DETAILSS_FAIL:
      state = {
        ...state,
        loader: false,
        updateInterviewMessage: null,
        interviewError: action.payload,
      };
      break;
    case REJECT_CANDIDATE:
      state = {
        ...state,
        loader: true,
        updateInterviewMessage: null,
        interviewError: null,
      };
      break;
    case REJECT_CANDIDATE_FAILURE:
      state = {
        ...state,
        loader: false,
        interviewError: action.payload,
        updateInterviewMessage: null,
      };
      break;
    case REJECT_CANDIDATE_SUCCESS:
      state = {
        ...state,
        loader: false,
        interviewError: null,
        updateInterviewMessage: action.payload,
      };
      break;
    case GET_INTERVIEW_ROUNDS:
      state = {
        ...state,
        loader: true,
        jobInterviewRounds: null,
      };
      break;
    case GET_INTERVIEW_ROUNDS_SUCCESS:
      state = {
        ...state,
        loader: false,
        jobInterviewRounds: action.payload,
      };
      break;
    case GET_INTERVIEW_ROUNDS_FAILURE:
      state = {
        ...state,
        loader: false,
        jobInterviewRounds: null,
      };
      break;
    case GET_INTERVIEW_RECORDINGS: {
      const { interviewId } = action.payload;

      state = {
        ...state,
        interviewRecordingsLoading: {
          ...state.interviewRecordingsLoading,
          [interviewId]: true,
        },
        interviewRecordingsError: {
          ...state.interviewRecordingsError,
          [interviewId]: null,
        },
      };
      break;
    }

    case GET_INTERVIEW_RECORDINGS_SUCCESS: {
      const { interviewId, data } = action.payload;

      state = {
        ...state,
        interviewRecordings: {
          ...state.interviewRecordings,
          [interviewId]: data,
        },
        interviewRecordingsLoading: {
          ...state.interviewRecordingsLoading,
          [interviewId]: false,
        },
        interviewRecordingsError: {
          ...state.interviewRecordingsError,
          [interviewId]: null,
        },
      };
      break;
    }

    case GET_INTERVIEW_RECORDINGS_FAILURE: {
      const { interviewId, error } = action.payload;

      state = {
        ...state,
        interviewRecordingsLoading: {
          ...state.interviewRecordingsLoading,
          [interviewId]: false,
        },
        interviewRecordingsError: {
          ...state.interviewRecordingsError,
          [interviewId]: error,
        },
      };
      break;
    }
    default:
      state = { ...state };
      break;
  }
  return state;
};
export default InterviewReducer;
